import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { AgrupamentoStringboxService } from 'src/app/services/agrupamento-stringbox.service';
import { CarregandoService } from 'src/app/services/carregando.service';
import { GlobalService } from 'src/app/services/global.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { ProdutoService } from 'src/app/services/produto.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';

@Component({
  selector: 'app-importar-agrupamento-stringbox-modal',
  templateUrl: './importar-agrupamento-stringbox-modal.component.html',
  styleUrls: ['./importar-agrupamento-stringbox-modal.component.scss']
})
export class ImportarAgrupamentoStringboxModalComponent implements OnInit {

  selectedFile: File;
  public config: PerfectScrollbarConfigInterface = {};

  constructor(public dialogRef: MatDialogRef<ImportarAgrupamentoStringboxModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private notificacaoService: NotificacaoService, private carregandoService: CarregandoService, private agrupamentoStringboxService: AgrupamentoStringboxService,
    public dialog: MatDialog) {
  }

  ngOnInit() {}


  importar() {

    if (this.selectedFile === null || this.selectedFile === undefined) {
      return;
    }

    const dados = new FormData();
    dados.append('arquivo', this.selectedFile);
    this.carregandoService.mostra('importar');
    this.agrupamentoStringboxService.importar(dados).subscribe((resp) => {
      this.carregandoService.esconde('importar');
      this.notificacaoService.sucesso('Agrupamentos importados com sucesso!!!');
      this.dialogRef.close(true);
    }, (erro) => {
      this.carregandoService.esconde('importar');
      this.notificacaoService.erro(erro);
    });
  }

  fechar() {
    this.dialogRef.close();
  }

  onFileChanged(event) {
    this.selectedFile = event.target.files[0];
  }

  excluirArquivo() {
    this.selectedFile = undefined;
  }
}
